export default "__VITE_ASSET__C$oEu7$U__"